import { React, useState } from "react";
import { Card, Badge, Image, Row, Col, Dropdown } from "react-bootstrap";
import "./TaskCard.css";
import { useNavigate } from "react-router-dom";
import { HiPencil } from "react-icons/hi2";
import { MdDelete } from "react-icons/md";

const TaskCard = ({ task, index, togglePopup, popupVisible }) => {
  const navigate = useNavigate();

  const gotomyTask = () => {
    navigate("/mytask");
  };

  return (
    <Card
      className="task-card-box p-0 mx-auto"
      style={{ backgroundColor: "#D8D8D8", borderRadius: "20px" }}
    >
      <div className="mx-auto task-card-item">
        <Row className="mb-2">
          <Col className="pt-1">
            <Badge bg="purplebox" className="task-enquiry" onClick={gotomyTask}>
              Enquiry
            </Badge>
          </Col>
          <Col className="text-end mb-0 pb-0">
            <Badge
              className="progress-main"
              bg="progressbox"
              onClick={gotomyTask}
            >
              <p className="progress-body">Progress</p>
            </Badge>
          </Col>

          <span className="dots mt-2" onClick={() => togglePopup(index)}>
            ...
          </span>

          {popupVisible && (
            <div
              className="task-popup-container p-0 m-0"
              style={{ width: "150px" }}
            >
              <button
                className="task-close-btn"
                onClick={() => togglePopup(index)}
              >
                &times;
              </button>
              <div className="task-popup-content w-100 p-1 ms-2">
                <div className="row d-flex justify-content-center align-items-center w-75">
                  <div className="col pt-1">
                    <div className="w-auto p-0 ms-0">
                      <HiPencil />
                      <br />
                      <MdDelete />
                    </div>
                  </div>
                  <div className="col pt-1 text-start">
                    <div>
                      Edit
                      <br />
                      Delete
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Row>

        <Card.Text className="task-description">
          Brainstorming brings team members' diverse experience into play.
        </Card.Text>

        <div>
          <div className="d-flex justify-content-between align-items-center mb-5">
            <p className="assignedBy">
              <b>Assigned By: </b>
              <span className="fw-bold text-black">Saravanan</span>
            </p>
            <Badge bg="primary assignedBy">Low</Badge>
          </div>
          <div>
            <div>
              <p className="assignedBy">
                <b className="text-start">Assigned To:</b>
                <div className="avatars mt-0">
                  {[1, 2, 3, 4].map((img, index) => (
                    <Image
                      key={index}
                      src={`https://i.pravatar.cc/40?img=${img}`}
                      roundedCircle
                      className="avatar-img"
                    />
                  ))}
                </div>
              </p>
            </div>
            <div>
              <p className="assignedBy text-end approvedBy pe-0">
                <b>Approve Person:</b>
                <div className="avatars1 text-end ps-2">
                  {[5, 6].map((num) => (
                    <Image
                      key={num}
                      src={`https://i.pravatar.cc/40?img=${num}`}
                      roundedCircle
                      className="avatar-img1 text-end"
                    />
                  ))}
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default TaskCard;
